import { Component, OnInit } from '@angular/core';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { LgaDto, StateDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-lga-container',
  templateUrl: './lga-container.component.html',
  styleUrls: ['./lga-container.component.scss']
})
export class LgaContainerComponent implements OnInit {


  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  states$: Observable<StateDto[]>;
  lgas$: Observable<LgaDto[]>;
  loading: boolean;
  isCompanyLoading$: Observable<boolean>;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isCompanyLoading$ = this.gatwayFacade.isLoadingGateway("State");
    this.states$ = this.gatwayFacade.loadGateway("State");
    this.states$.subscribe(data => {
      console.log("state data.",data);
    })
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("Lga");
    this.lgas$ = this.gatwayFacade.loadGateway("Lga");
    this.lgas$.subscribe(data => {
      console.log("lga data.",data);
    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLga(deletedValue: any) {
    this.gatwayFacade.remove("Lga", deletedValue);
    // this.store.dispatch(LgaStoreActions.removeLga({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }

// this method control both the create and update
  onSubmitLga(formValue: any) {
    console.log("form value: ", formValue);
    formValue.Lgas = formValue.Lgas.reverse();
    const pullData = formValue.Lgas;
    //const newPullData = formValue.Lgaes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllLga = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllLga.push(pullData[i]);
    }
  }

// check if the addAllLga array is not empty, then dispatch the data to the store
   if(addAllLga.length !== 0) {
    this.gatwayFacade.add('Lga', addAllLga);
    // this.store.dispatch(LgaStoreActions.addLga({newLga: addAllLga}));
   }

// dispatch update data to the store
    this.gatwayFacade.update('Lga', allUpdates, ['id']);
    // this.store.dispatch(LgaStoreActions.updateLga({updateLga: allUpdates}));
    this.notificationService.success('Saved Successfully');
  }

}
